<template>
    <div>
        <div v-if="showHint" class="position-overlay">
            <div class="position-guide">
                <div class="position-outline">
                    <div class="position-content">
                        <font-awesome-icon :icon="['fas', 'camera-viewfinder']" class="position-icon" />
                        <div class="position-text">{{ $t('sign_feedback.direct_record.overlay_hint') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="checking" class="positioning-feedback-overlay">
            <div class="positioning-feedback-content">
                <div class="position-guide">
                    <div class="position-outline">
                        <div class="position-content">
                            <font-awesome-icon v-if="!valid" :icon="['fas', 'camera-viewfinder']" class="position-icon" />
                            <font-awesome-icon v-else :icon="['fas', 'circle-check']" class="position-icon success" />
                            <div class="position-text">{{ message }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class PositionOverlay extends Vue {
    @Prop({ type: Boolean, required: true }) checking!: boolean;
    @Prop({ type: Boolean, required: true }) valid!: boolean;
    @Prop({ type: String, required: true }) message!: string;
    @Prop({ type: Boolean, default: false }) showHint!: boolean;
}
</script>

<style lang="scss" scoped>
.position-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 10;
}
.position-guide {
    width: 60%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}
.position-outline {
    width: 100%;
    height: 100%;
    border: 2px dashed rgba(255, 255, 255, 0.55);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    position: relative;
    box-sizing: border-box;
}
.position-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
}
.position-icon {
    color: rgba(255, 255, 255, 0.8);
    font-size: 2rem;
}
.position-icon.success { color: #28a745; }
.position-text {
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    font-weight: 500;
    text-align: center;
    background: rgba(0, 0, 0, 0.4);
    padding: 0.5rem 1rem;
    border-radius: 6px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.positioning-feedback-overlay .position-text {
    font-size: clamp(0.9rem, 0.6rem + 1.2vw, 1.35rem);
}
.position-actions { margin-top: 0.75rem; }
.positioning-feedback-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 20;
}
.positioning-feedback-content {
    pointer-events: auto;
    background: transparent;
    padding: 0;
    text-align: center;
    max-width: 100%;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.positioning-feedback-overlay .position-outline {
    padding: 1rem;
}
.positioning-feedback { display: contents; }
.feedback-icon, .feedback-text { display: none; }
@media (max-width: 640px) {
    .positioning-feedback-content {
        padding: 0;
        max-width: 100%;
    }
    .position-icon { font-size: 2rem; }
    .position-text { font-size: clamp(0.85rem, 0.8rem + 0.5vw, 1rem); }
}
</style>

 